export const getVideos = state => state.resources.videos.videos;
export const getVideo = (state, props) => state.resources.videos.videos[props.playerId];
export const getVideoFetchStatus = (state, props) => state.resources.videos.video2FetchStatus[props.playerId];